import { makeAPIRequest } from "./makeRequest";

interface configData  {
    method: string;
    url: string;
    headers: Record<string, string>;
    data?: any;
}

let config: configData = {
    method: 'POST',
    url:"",
    headers: {}
}

export const FileUpload = (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    config.url = process.env.REACT_APP_SERVER_URL + 'HTMLFile/UpdateFile';
    config.headers = {
        'Accept': 'application/json',
    };
    config.data = formData

    let res = makeAPIRequest(config);
    return res;
}